export default {
  namespaced: true,
	state: {
    request: null,
    quotation: {
      init: null,
      error: false,
      quote: {
        fromHotel: '',
        fromHotelId: '',
        toHotel: '',
        toHotelId: '',
        prices: [],
      }
    }
	},

	getters: {
    getQuotation(state){ //take parameter state
      return state.quotation
    }
	},

	actions: {
    setData({commit}, quotation) {
      commit('setData', quotation)
    },
    setRequest({commit}, request) {
      commit('setRequest', request)
    }
	},
  
	mutations: {
    setData(state, quotation) {
      state.quotation = quotation
      state.quotation.init = true
    },
    setRequest(state, request) {
      state.request = request
    }
	}
}